import React from 'react';
import { Formik } from 'formik';
import { debounce } from 'lodash';
import classNameBind from 'classnames/bind';
import _isEqual from 'lodash/isEqual';
import FormContext from './context';
import styles from './autoSaved.module.css';

const bindClasses = classNameBind.bind(styles);

export default (options = { saveOnBlur: false, saveOnChange: false, debounceWait: 0 }) => (WrappedComponent) => {
  const AutoSaved = React.forwardRef((props, ref) => {
    const {
      name,
      initialValue,
      onSubmit,
      validationSchema,
    } = props;

    return (
      <Formik
        enableReinitialize
        initialValues={{
          [name]: initialValue,
        }}
        validationSchema={validationSchema}
        validateOnBlur
        validateOnChange
        ref={ref}
        onSubmit={debounce((values, api) => {
          if (!_isEqual(values[name], initialValue)) {
            onSubmit(values, api);
          } else {
            api.setSubmitting(false);
          }
        }, options.debounceWait)}
        render={(api) => {
          const wrappedProps = {
            ...props,
            onChange: options.saveOnChange ? (event) => {
              api.setFieldValue(event.target.name, event.target.value, true);
              api.setFieldTouched(event.target.name, true);
              setTimeout(() => api.submitForm(), 0);
            } : api.handleChange,
            onBlur: options.saveOnBlur ? (event) => {
              api.setFieldValue(event.target.name, event.target.value, true);
              api.setFieldTouched(event.target.name, true);
              setTimeout(() => {
                api.submitForm();
              }, 0);
            } : api.handleBlur,
          };

          return (
            <FormContext.Provider value={api}>
              <form onSubmit={api.handleSubmit} noValidate className={bindClasses('autoSaved')}>
                <WrappedComponent {...wrappedProps} />
              </form>
            </FormContext.Provider>
          );
        }}
      />
    );
  });

  return AutoSaved;
};
